import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatChip, MatChipList } from '@angular/material/chips';
import * as uuid from 'uuid';

export interface ChipListSelectOption {
    label: string;
    value: any;
}

@Component({
    selector: 'app-chip-list',
    templateUrl: './chip-list.component.html',
    styleUrls: ['./chip-list.component.scss'],
})
export class ChipListComponent implements OnInit, AfterViewInit, ControlValueAccessor {
    public onChange: (v?: any) => {};
    public onTouched: () => {};
    public id: string;
    public _value: any;

    selectedChips: any[] = [];

    @ViewChild('chipList')
    private chipList: MatChipList;

    @Input() options: ChipListSelectOption[] = [];
    @Input() class: string = '';
    @Input() disabled: boolean;
    @Input() validation: boolean = true;
    @Input() disableMessages: boolean = false;

    @Output('change') changeOutput = new EventEmitter<any>();
    @Output() blur = new EventEmitter<Event>();

    @Input()
    get value(): any {
        return this._value;
    }

    set value(v: any) {
        this._value = v;
        this.changeOutput.emit(v);
        if (this.onChange) {
            this.onChange(v);
            this.onTouched();
        }
    }

    get invalid() {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid() {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine() {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty() {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched() {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    constructor(
        private cdr: ChangeDetectorRef,
        @Self() @Optional() private ngControl: NgControl,
    ) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    ngAfterViewInit(): void {
        this.updateChipsDisplayOnValueUpdate();
    }

    change(v) {
        this._value = v;
    }

    writeValue(value: any): void {
        this.value = value;
        this.updateChipsDisplayOnValueUpdate();
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }

    updateChipsDisplayOnValueUpdate() {
        this.chipList?.chips?.forEach((chip) => {
            if (this.value.includes(chip.value)) {
                this.selectedChips.push(chip.value);
                chip.toggleSelected();
                this.cdr.detectChanges();
            }
        });
    }

    select(chip: MatChip, option: ChipListSelectOption) {
        chip.toggleSelected();
        if ((chip.value || '').trim()) {
            if (chip.selected) {
                this.selectedChips.push(chip.value);
            } else {
                this.selectedChips = this.selectedChips.filter((selectedChip) => selectedChip !== chip.value);
            }
        }
        this.value = this.selectedChips;
    }
}
